import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import '@/index.css';
import { isInsideShopifyAdmin, loadAppBridge } from '@/lib/app-bridge';

async function bootstrap() {
  if (isInsideShopifyAdmin()) {
    await loadAppBridge(import.meta.env.VITE_SHOPIFY_API_KEY);
  }

  const root = document.getElementById('root');
  if (!root) {
    throw new Error('Missing #root element in index.html');
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
